import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { connectedReduxRedirect, connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import {React} from 'react'



const locationHelper = locationHelperBuilder({})

function LoadingScreen(){
    return(
        <div>(auth manager) Loading...</div>
    )
}

export const UserIsAuthenticated = connectedRouterRedirect({
    redirectPath: '/login',
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) => !auth.isLoaded || isInitializing === true,
    authenticatedSelector: ({ firebase: { auth } }) => auth.isLoaded && !auth.isEmpty,
    AuthenticatingComponent: LoadingScreen,
    wrapperDisplayName: 'UserIsAuthenticated',
    allowRedirectBack: false,



});

export const UserIsNotAuthenticated = connectedRouterRedirect({

    redirectPath: '/profile',
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) => !auth.isLoaded || isInitializing === true,
    authenticatedSelector: ({ firebase: { auth } }) =>  auth.isLoaded && auth.isEmpty,
    AuthenticatingComponent: LoadingScreen,
    wrapperDisplayName: 'UserIsNotAuthenticated',
    allowRedirectBack: false,

});